module.exports = require('./assign');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/object/extend.js
 ** module id = 279
 ** module chunks = 1
 **/